/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

const globalDelegateContainer = new domDelegate.Delegate(document.querySelector('body'));
globalDelegateContainer.on('click', '[data-action="ajax-add-to-cart"]', function() {
  const parentContainer = this.closest('.ProductItem');
  const _this = this;

  if(parentContainer) {
    let variantId = "";
    if(parentContainer.querySelector('[data-variant-id]:checked')) {
      variantId = parentContainer.querySelector('[data-variant-id]:checked').getAttribute('data-variant-id'); 
    } else {
      variantId = this.getAttribute('data-variant-id'); 
    }

    this.setAttribute('disabled', 'disabled');
    document.dispatchEvent(new CustomEvent('theme:loading:start')); // Then we add the product in Ajax

    fetch("".concat(window.routes.cartAddUrl, ".js"), {
      body: JSON.stringify({
        quantity: 1,
        id: variantId
      }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

      }
    }).then(function (response) {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      if (response.ok) {
        _this.removeAttribute('disabled'); // We simply trigger an event so the mini-cart can re-render

        document.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
          }
        }));

      } else {
        response.json().then(function (content) {
          var errorMessageElement = document.createElement('span');
          errorMessageElement.className = 'ProductForm__Error Alert Alert--error';
          errorMessageElement.innerHTML = content['description'];
          _this.removeAttribute('disabled');
          _this.insertAdjacentElement('afterend', errorMessageElement);
          setTimeout(function () {
            errorMessageElement.remove();
          }, 2500);
        });
      }
    });
  }
});


